export interface ILeaderboardPartialTable {
  id: number;
  name: string;
  sortAsc: boolean;
  date: string;
  minValue: number;
  maxValue: number;
  recordsLimit: number;
  allowGuestScores: boolean;
}